/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCheckbold from '@telus-uds/palette-allium/build/rn/icons/Checkbold'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { backgroundColor: '#414547' } },
    { if: { pressed: true }, tokens: { backgroundColor: '#2c2e30' } },
    {
      if: { focus: true },
      tokens: {
        outerBorderColor: '#676e73',
        outerBorderGap: 3,
        outerBorderWidth: 2
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: {
        outerBorderColor: '#2c2e30',
        outerBorderGap: 3,
        outerBorderWidth: 2
      }
    },
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#2b8000',
        icon: PaletteIconCheckbold,
        iconColor: '#2b8000'
      }
    },
    {
      if: { hover: true, selected: true },
      tokens: { backgroundColor: '#1f5c09', iconColor: '#1f5c09' }
    },
    {
      if: { pressed: true, selected: true },
      tokens: { backgroundColor: '#163e06', iconColor: '#163e06' }
    },
    {
      if: { focus: true, selected: true },
      tokens: { outerBorderColor: '#676e73', outerBorderWidth: 2 }
    },
    {
      if: { focus: true, pressed: true, selected: true },
      tokens: { outerBorderColor: '#163e06', outerBorderWidth: 2 }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#b2b9bf',
        iconColor: '#b2b9bf',
        labelColor: '#b2b9bf',
        outerBorderColor: '#b2b9bf'
      }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#676e73',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 32,
    borderWidth: 0,
    containerWidth: null,
    icon: null,
    iconColor: '#676e73',
    iconSize: 14,
    labelColor: '#414547',
    labelFontName: 'HNforTELUSSA',
    labelFontSize: 16,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    labelMarginLeft: 0,
    mobileSwitchSize: 24,
    mobileTrackBorderWidth: 4,
    mobileTrackHeight: 32,
    mobileWidth: 48,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 0,
    outerBorderGapButton: 3,
    outerBorderWidth: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    shadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: true,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    },
    space: 2,
    switchBorderColor: 'rgba(0, 0, 0, 0)',
    switchBorderRadius: 32,
    switchBorderWidth: 0,
    switchColor: '#ffffff',
    switchShadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.2)',
      inset: false,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    },
    switchSize: 18,
    trackBorderColor: 'rgba(0, 0, 0, 0)',
    trackBorderRadius: 32,
    trackBorderWidth: 3,
    trackHeight: 24,
    width: 40
  }
}
export default theme
